export default function (state, getters) {
    return getters['agreements/loading']||getters['regulars/loading']||getters['invoices/loading'];
}